module.exports = __webpack_public_path__ + "static/media/pasc.e452aea7.svg";